import React from 'react';
import { useTranslation } from 'react-i18next';
import { Search } from '@carbon/react/icons';
import { useGlobalSearchTrigger } from 'src/components/GlobalSearch';

/** navigator.platform is deprecated; the user agent is what still reports the modifier. */
function isApplePlatform(): boolean {
  return typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);
}

export const HeaderSearchTrigger = React.memo(() => {
  const { t } = useTranslation();
  const { open } = useGlobalSearchTrigger();

  return (
    <button
      type="button"
      id="global-search-button"
      className="shell-search"
      aria-label={t('globalSearch.openLabel')}
      onClick={() => open()}
      onKeyDown={(event) => {
        // Space and Enter already reach onClick through the button's native behaviour, and a
        // chord belongs to the document-level shortcut, not to this control.
        if (event.key.length !== 1 || event.key === ' ') return;
        if (event.metaKey || event.ctrlKey || event.altKey) return;
        event.preventDefault();
        open(event.key);
      }}
    >
      <Search size={16} className="shell-search__icon" />
      <span className="shell-search__placeholder">{t('globalSearch.placeholder')}</span>
      <kbd className="shell-search__hint">{isApplePlatform() ? '⌘K' : 'Ctrl K'}</kbd>
    </button>
  );
});
